<template>
  <svg
    width="22px"
    height="22px"
    viewBox="0 0 22 22"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g id="00-Framework" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="Framework" transform="translate(-1292.000000, -402.000000)" fill="currentColor">
        <g id="typo" transform="translate(347.000000, 303.000000)">
          <g id="Group-3" transform="translate(-0.000000, -0.000000)">
            <g id="Presets" transform="translate(944.000000, 14.000000)">
              <g id="zimmer" transform="translate(0.000000, 84.000000)">
                <g id="Planning-/-Travel-/-hotel-/-24">
                  <path
                    d="M7.125,11.25 C7.74632034,11.25 8.25,11.7536797 8.25,12.375 C8.25,12.9963203 7.74632034,13.5 7.125,13.5 C6.50367966,13.5 6,12.9963203 6,12.375 C6,11.7536797 6.50367966,11.25 7.125,11.25 L7.125,11.25 Z M7.125,9.75 C5.67525253,9.75 4.5,10.9252525 4.5,12.375 C4.5,13.8247475 5.67525253,15 7.125,15 C8.57474747,15 9.75,13.8247475 9.75,12.375 C9.75,10.9252525 8.57474747,9.75 7.125,9.75 L7.125,9.75 Z M18.75,10.5 L12.75,10.5 C11.9215729,10.5 11.25,11.1715729 11.25,12 L11.25,16.5 L3,16.5 L3,7.95 L12,3.105 L21.3975,8.16 L22.1025,6.84 L12.3525,1.59 C12.1321459,1.47266641 11.8678541,1.47266641 11.6475,1.59 L1.8975,6.84 C1.65348962,6.96992877 1.50073764,7.22355469 1.5,7.5 L1.5,22.5 L3,22.5 L3,18 L21,18 L21,22.5 L22.5,22.5 L22.5,14.25 C22.5,12.1789322 20.8210678,10.5 18.75,10.5 Z M12.75,16.5 L12.75,12 L18.75,12 C19.9926407,12 21,13.0073593 21,14.25 L21,16.5 L12.75,16.5 Z"
                    id="Fill"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'Room'
};
</script>
